import { render, staticRenderFns } from "./TeacherCourse.vue?vue&type=template&id=0746814a"
import script from "./TeacherCourse.vue?vue&type=script&lang=js"
export * from "./TeacherCourse.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourse.vue?vue&type=style&index=0&id=0746814a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports